"use client";

import { Button } from "@workspace/ui/components/button";
import { KeyboardShortcut } from "@workspace/ui/components/keyboard-shortcut";
import { useSidebar } from "@workspace/ui/components/sidebar";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@workspace/ui/components/tooltip";
import { PanelLeftIcon } from "lucide-react";

type SidebarHeaderTriggerProps = {
  className?: string;
};

export function SidebarHeaderTrigger({ className }: SidebarHeaderTriggerProps) {
  const { toggleSidebar } = useSidebar();

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            className={className}
            data-sidebar="trigger"
            onClick={toggleSidebar}
            size="icon"
            variant="ghost"
          />
        }
      >
        <PanelLeftIcon />
        <span className="sr-only">Toggle Sidebar</span>
      </TooltipTrigger>
      <TooltipContent className="flex items-center gap-1">
        Abrir/Cerrar menú
        <KeyboardShortcut keyLabel="B" modifier="cmd" />
      </TooltipContent>
    </Tooltip>
  );
}
